export const SERVER_PORT = 4000;
export const CLIENT_PORT = 3000;

declare const process: {
  env: {
    EXPO_PUBLIC_NGROK_URL: string | null | undefined;
    EXPO_PUBLIC_MONORAILS_URL: string | null | undefined;
    NEXT_PUBLIC_NGROK_URL: string | null | undefined;
    NEXT_PUBLIC_MONORAILS_URL: string | null | undefined;
    NEXT_PUBLIC_VERCEL_ENV: 'development' | 'preview' | 'production' | 'demo' | 'staging' | null | undefined;
    NEXT_PUBLIC_VERCEL_TARGET_ENV: string | null | undefined;
    NODE_ENV: 'development' | 'production' | 'test' | null | undefined;
  };
};

// Bundlers inline an unset `*_PUBLIC_*` var as '', which `??` accepts as configured — so every
// fallback below is `||`, and each `process.env.X` stays a literal member expression to stay inlinable.
const ngrokUrl = process.env.NEXT_PUBLIC_NGROK_URL?.trim() || process.env.EXPO_PUBLIC_NGROK_URL?.trim();
const monorailsUrl = process.env.NEXT_PUBLIC_MONORAILS_URL?.trim() || process.env.EXPO_PUBLIC_MONORAILS_URL?.trim();
const vercelEnvToMonorailsApiHost: Record<string, string> = {
  development: `http://localhost:${SERVER_PORT}`,
  preview: 'https://api.savvywealth.com',
  production: 'https://api.savvywealth.com',
  demo: 'https://api-demo.savvywealth.com',
  staging: 'https://monorails.workloads.staging.aws.savvy.sh',
};

const vercelEnv =
  process.env.NEXT_PUBLIC_VERCEL_TARGET_ENV === 'staging' ? 'staging' : process.env.NEXT_PUBLIC_VERCEL_ENV;
const resolvedEnv = vercelEnv ?? process.env.NODE_ENV ?? 'development';

// ngrok stays ahead of NEXT_PUBLIC_MONORAILS_URL in development only: docker-compose always
// injects the latter, so an opted-in tunnel would otherwise be silently shadowed.
export const apiHost =
  (resolvedEnv === 'development' ? ngrokUrl : undefined) || monorailsUrl || vercelEnvToMonorailsApiHost[resolvedEnv];
